import { useEffect } from "react";
import { ErrorBox as EhrBox } from "@metriport/shared-internal";

export function getAuthUrl(): string {
  return process.env.REACT_APP_SALESFORCE_AUTHORIZE_URL!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
}

export function getRedirectUri(): string {
  return process.env.REACT_APP_SALESFORCE_REDIRECT_URI!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
}

export default function LaunchPage() {
  const inputParams = new URLSearchParams(location.search);
  const patientId = inputParams.get("patientId");
  const clientId = inputParams.get("clientId");

  const state = JSON.stringify({ patientId, clientId });

  const redirectParams = new URLSearchParams();
  redirectParams.append("response_type", "code");
  // TODO ENG-1108: reduce scope to only what we need
  redirectParams.append("scope", "api id openid profile cdp_profile_api");
  redirectParams.append("client_id", clientId ?? "");
  redirectParams.append("redirect_uri", getRedirectUri());
  redirectParams.append("state", state);

  const redirectUrl = `${getAuthUrl()}?${redirectParams.toString()}`;

  useEffect(() => {
    function callRedirect() {
      window.location.replace(redirectUrl);
    }
    callRedirect();
  }, []);

  if (!patientId || !clientId) {
    return (
      <EhrBox>
        Something went wrong. Please try using the app from the Salesforce Contact page.
      </EhrBox>
    );
  }

  return <EhrBox>Launching...</EhrBox>;
}
